import { isEmpty, negate } from "lodash";

export const isNotEmpty = negate(isEmpty);
